/**
 * @fileoverview Application entry point.
 * @summary Initializes React app with i18n and renders root component.
 *
 * @package KaraoNow
 * @module apps/front/src/main
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './utils/i18n/index.js' // Initialize i18n
import { getInitialTheme, applyTheme } from './hooks/useTheme.js'
import App from './App.tsx'

// Initialize theme before rendering
const initialTheme = getInitialTheme()
applyTheme(initialTheme)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

